
const nameBOT = 'virtual';
const namePerson = '';
let messageInput: JQuery<HTMLInputElement>
let sendButton: JQuery<HTMLButtonElement>
let chat: JQuery<HTMLElement>
let narrator: JQuery<HTMLImageElement>
let imgSystem: string
let imgUser: string
declare const marked: any;

var aptChat: any = aptChat || {};
aptChat = (function ($: JQueryStatic) {

	function _init() {
		initEvents();
		localStorage.removeItem('chatHistory');
		imgSystem = $('#imgSystem').html();
		imgUser = $('#imgUser').html();
		chat = $('#chat');
		narrator = $('#narrator');

		const startMessage: string = $('#startMessage').val() as string
		saveMessageToHistory('system', startMessage)
		if (startMessage.trim() !== '') _addChatMessage(nameBOT, imgSystem, 'left', startMessage)
	}

	function _askChatbot(message: string) {
		_addChatMessage(namePerson, imgUser, 'right', message);
		const chatSession = saveMessageToHistory("user", message);
		chatSession.WebId = apt.sm.webId
		chatSession.NodeNumber = apt.sm.getNodeNumber()

		const antiForgeryToken = $('input[name="__RequestVerificationToken"]').val();
		$.ajax({
			url: '../Chat/Chatbot',
			type: 'POST',
			headers: {
				'RequestVerificationToken': antiForgeryToken
			} as Record<string, string>,
			data: JSON.stringify(chatSession),
			async: true,
			contentType: 'application/json',
			success: function (data: ChatResponse) {
				let messageParts = data.message.split('|');
				let assistantResponse = messageParts[2];
				_addChatMessage(nameBOT, imgSystem, 'left', assistantResponse)
				updateHistory(data.message);
				$('.loader').hide();
				updateSession(data);
			},
			error: function (error: any) {
				_addChatMessage(nameBOT, imgSystem, 'left', 'Sorry, could you repeat that?');
				console.error('Error:', error.responseJSON);
				$('.loader').hide();
			},
			complete: apt.timer.init()
		})
	}

	function updateSession(data: ChatResponse) {
		if (data.status === 'Complete' || data.status === 'Finish') {
			const promise = Promise.resolve($('.card-chat, .left .inner').fadeOut())
				.then(() => {
					$('.card-chat').load(`../Chat/GetStep?webId=${apt.sm.webId}&status=Complete`).fadeIn();
					console.info(data);
				})
				.then(() => {
					$('.left').load(`../Chat/GetStep?webId=${apt.sm.webId}&status=Finish .inner`, (img) => {
						$('.left').find('img').prop('src', $(img).prop('src'));
						console.info(img);
					}).fadeIn();
					console.info(data);
				})
				.finally(() => $('.card-chat, .left .inner').fadeIn());

			return promise;
		}
		else if (data.resourceName !== 'Start') {
			if (data.resourceType === 'Image') {
				const img = data.resourceFileName.replace('~', siteUrl);
				if (narrator.prop('src') !== img)
					narrator.prop('src', img);
			}
			else {
				$('.left').load(`../Chat/GetStep?webId=${apt.sm.webId}&status=${data.resourceName} .inner`, (data) => {
					console.log(data);
				});
			}
		}

		console.info(data);
	}

	function _addChatMessage(name: string, img: string, side: string, text: string) {
		const timeFormat = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit' }).format;

		//let htmlContent = marked.parse(text);
		let msgHTML = document.querySelector('#msgTemplate')?.innerHTML || ''
		let info = timeFormat(new Date())

		msgHTML = msgHTML?.replace(/{side}/g, side)
		msgHTML = msgHTML?.replace(`{img}`, img)
		msgHTML = msgHTML?.replace(`{info}`, info)
		msgHTML = msgHTML?.replace(`{htmlContent}`, text) //htmlContent.toString())

		const msg = $.parseHTML(msgHTML!)

		chat.append(msg)

		if (side == 'right') {
			var loaderHTML = `<div class="loader"></div>`
			chat.append($(loaderHTML))
		}

		scrollToBottom()
	}

	function scrollToBottom() {
		chat.scrollTop(chat.prop("scrollHeight"))
	}

	function saveMessageToHistory(role: string, content: string): ChatHistory {
		const chatHistory = getChatHistory()
		chatHistory.Messages.push(new ChatMessage(role, content))
		localStorage.setItem('chatHistory', JSON.stringify(chatHistory))
		return chatHistory
	}

	function updateHistory(response: string) {
		const chatHistory = getChatHistory()
		chatHistory.Messages.push(new ChatMessage("assistant", response))
		localStorage.setItem('chatHistory', JSON.stringify(chatHistory))
	}

	function getChatHistory(): ChatHistory {
		const chatHistory = localStorage.getItem('chatHistory')
		return chatHistory ? JSON.parse(chatHistory) : new ChatHistory()
	}

	class ChatHistory {
		public Messages: ChatMessage[] = [];
		public ChatSessionId: number = -1;
		public ChatSessionMessageNum: number = 1;
		public WebId: string = '';
		public NodeNumber: number = 0;
		public ItemNumber: number = 1;
	}

	class ChatResponse {
		public message: string = '';
		public status: string = '';
		public resourceTitle: string = '';
		public resourceFileName: string = '';
		public resourceName: string = '';
		public resourceType: string = '';
		public html: string = '';
	}

	class ChatMessage {

		public constructor(role: string, content: string) {
			this.Role = role;
			this.Content = content;
		}

		public Role: string;
		public Content: string;
	}

	function initEvents() {

		sendButton = $('#sendButton')
		messageInput = $('.item-textarea')
		$('#next').css('display', 'none !important').css('opacity', '0');

		sendButton
			.on('click', (e) => {
				e.preventDefault()
				const message = messageInput.val()?.trim() as string
				if (message.length < 2) return
				_askChatbot(message)
				messageInput.val('')
			})

		$(document)
			.on('keyup', messageInput, (e) => {
				if (e.shiftKey && e.code === 'Enter') {
					e.preventDefault();
				}
				else if (e.code === 'Enter') {
					e.preventDefault()
					sendButton.trigger('click')
				}
			})
	}

	return {
		init: _init,
		askChatbot: _askChatbot,
		addChatMessage: _addChatMessage
	}
})($);
